export default __webpack_public_path__ + "4aa4855af7df964d783ca5c50953da11.svg";